export const bookingType = {
	STANDARD: 1,
	GUEST_PERMISSION: 2,
	LOCKER: 3
};
